//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../funcionales/FormContent";
import MarcoModal from "../funcionales/MarcoModal";
import CloseButton from "../buttons/CloseButton";
import TextButton from "../buttons/TextButton";
import Loading from "../../routes/Loading";
//------------------------------------------------------ funciones
import { submitVehiculo } from "./data/Submits";
import { elementos } from "./data/FormContent";
import { cargarSelects } from "../../functions/dataFunctions";
//------------------------------------------------------ estilos
import { useCerrarConEsc } from "../../hooks/useCerrarConEsc";
import "./css/Forms.css";

const FormVehiculo = ({ elemento = null, onGuardar, onClose }) => {
  useCerrarConEsc(onClose);

  const modoEdicion = !!elemento;
  const titulo = modoEdicion ? "Editar" : "Agregar";
  const subtitulo = "Vehiculo";
  const campos = elementos["vehiculos"];

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); //para los selects, recibe un array tipo {tractores: ..., furgones: ...}
  const [formData, setFormData] = useState({
    // información específica
    id: elemento?.id || "",
    chasis: elemento?.chasis || "",
    dominio: elemento?.dominio || "",
    marca: elemento?.marca || "",
    modelo: elemento?.modelo || "",
    motor: elemento?.motor || "",
    // información laboral
    empresa: elemento?.empresa || "",
    persona: elemento?.persona || "",
    estado: elemento?.estado || false,
    // detalles y comentarios
    detalle: elemento?.detalle || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects();
      setListas(data);
    };

    cargarDatos();
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitVehiculo(
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      modoEdicion,
      elemento?.id,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="form-content">
          <CloseButton onClose={onClose} />

          <h1 className="form-header">
            <span className="form-titlebottom">{titulo}</span>
            <strong className="form-title">{subtitulo}</strong>
          </h1>

          <hr />

          <FormContent
            elemento={elemento}
            campos={campos}
            opciones={listas}
            data={formData}
            setData={setFormData}
          />

          <div className="form-buttons">
            <TextButton
              text={"Guardar"}
              type={"button"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormVehiculo;
